import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-182" data-mp="3kpugtgqsmnhi">
      <div className="mx-auto max-w-5xl" data-id="element-183" data-mp="3ksgwy4rr2bbc">
        <h2 className="text-center font-display text-[1.75rem] font-black leading-tight tracking-tight text-ink sm:text-[2.4rem]" data-id="element-184" data-mp="3fyvxs9ef7bak">
          Cosa dicono i docenti
        </h2>
        <p className="mt-3 text-center text-sm font-medium text-ink/70" data-id="element-185" data-mp="36yzg4rqg7cp0">
          <span aria-hidden="true" data-id="element-186" data-mp="36wwetbjuhx4z">⭐️⭐️⭐️⭐️⭐️</span> 4.9/5 · +2.000 docenti
        </p>

        <div className="mx-auto mt-10 grid max-w-4xl gap-5 sm:grid-cols-3" data-id="element-187" data-mp="31yl5r31djqnt">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col rounded-2xl bg-sand p-6" data-id="element-188" data-mp="2x2mnlx6n34vu">
              <div className="text-sm text-amber-500" aria-label="5 stelle su 5" data-id="element-189" data-mp="v9yfpaj1vt9q">
                <span aria-hidden="true" data-id="element-190" data-mp="qbn3wu9738ov">★ ★ ★ ★ ★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-display text-sm italic leading-relaxed text-ink/85" data-id="element-191" data-mp="h5oq3c5zm87y">
                &ldquo;{item.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6" data-id="element-192" data-mp="780ivmr7388w">
                <p className="text-xs font-bold text-ink" data-id="element-193" data-mp="7924um9r1f5e">{item.name}</p>
                <p className="text-xs text-ink/50" data-id="element-194" data-mp="c623ic49rfmh">{item.location}</p>
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-8 text-center text-[11px] text-ink/40" data-id="element-195" data-mp="zx7rjekd5e7v">
          Testimonianze illustrative a scopo dimostrativo.
        </p>
      </div>
    </section>;
}